<template>
  <div id="housing_relet" class="container">
    <!-- NavBar 导航栏 -->
    <nav-bar
      class="nav_fixed"
      rightWidth="16vw"
      :isExam="true"
      backPath="/housingRental"
    >
      <i slot="left-icon" class="public_icon icon-back"></i>
      <div slot="center">房屋在线续租</div>
    </nav-bar>

    <div class="pay_group" v-show="!isNodata">
      <div >
  
        <div class="houseGroup_info">
          <div class="info_list">
            <div class="left_info">上次到期时间：</div>
            <div class="right_info">{{ timeFormat(expirationTime, "yyyy-MM-dd") }}</div>
            
          </div>
          
          <div class="info_list">
            <p class="tips">
              <b class="red">注：续租起始时间为：到期的第2天</b>
            </p>
          </div>
          <div class="info_list">
            <div class="left_info">续租时间：</div>
            <div class="right_info" @click.stop="pickerClick">{{ reletTime == "" ? "选择时间" : reletTime+'个月' }}</div>
          </div>
          <div class="info_list">
            <div class="left_info">租赁时间：</div>
            <!-- @click.stop="leaseClick" -->
            <div class="right_info" >
              <span :class="startData == '' ? 'gary' : ''">{{ startData == "" ? "起始时间" : startData }} </span>
              至
              <span :class="startData == '' ? 'gary' : ''">{{ endData == "" ? "截止时间" : endData }}  </span>
              
            </div>
          </div>
          <div class="info_list">
            <div class="left_info">租金合计：</div>
            <div class="right_info " :class="rent1? 'gary' : ''">
              {{ !rent1 ? "未设置" : rent1+'元' }}
            </div>
          </div>
          <div class="info_list">
            <div class="left_info">保险费：</div>
            <div class="right_info gary">
              <van-checkbox
              @click.stop="insureClick()"
              style="width: 30px;"
              class="checkbox"
              icon-size="18px"
              :disabled="insureDisabled"
              v-model="insureChecked"
            ></van-checkbox>
              {{ insurance == "" ? "0元" : insurance+'元' }}
            </div>
          </div>

          <div class="table_footer">
           
            <div class="table_Record">
              <div>
                <van-checkbox
              @click.stop="checkboxClick()"
              style="width: 30px;"
              class="checkbox"
              icon-size="18px"
              v-model="checked"
            ></van-checkbox>
                上周期内租赁合同续租期间继续有效</div>
              <div>
                <router-link
                  style="color: #5391ff;"
                  :to="{
                    name: 'AgreementRecord',
                    path: '/agreementRecord',
                    params:{
                      id:1
                    }
                  }"
                  >
                查看已签订的租赁合同
                </router-link>
              </div>
              
            </div>
            
          </div>
          
        </div>
        <p class="tips2">
          <b class="red">注：在线续租不能变更房间和续租周期，如需变更请联系宿管人员后台操作。</b>
        </p>
        
        <button type="button" class="btn-submit" @click="submitClick()" :disabled="isDisabled" :class="isDisabled?'opacity':''">
          点击提交续租
        </button>
       
      </div>
    </div>
    <!-- 没有数据 -->
    <nodata style="width: 100%" :nodata="nodata" v-show="isNodata"></nodata>

    <Foot class="foot" :class="{ none: isNodata || pickerShow }"></Foot>

    <!-- 续租下拉 -->
    <van-popup
      @close="closePopup"
      v-model="pickerShow"
      position="bottom"
      style="height: 49%"
      round
    >
      <van-picker
        ref="pickerRef"
        v-model="reletTime"
        :columns="columns"
        show-toolbar
        @cancel="closePopup"
        @confirm="onConfirm"
      />
    </van-popup>

    <!-- 待签订状态提示 -->
    <Modal
        :isShow="isModal2"
        topsite="30%"
        rightsite="10%"
        leftsite="10%"
        margintop="-25px"
      >
        <div slot="modalContent">
          <div class="item_title">提示</div>
          <div class="item_content">
            <p>上周期内您的租赁还没有完成签订，请先完成签订确认</p>
          </div>
          <div class="true_btn blue_font" @click="closeModal2">确定</div>
        </div>
      </Modal>

      <Modal
        :isShow="isModalRelet"
        topsite="30%"
        rightsite="10%"
        leftsite="10%"
        margintop="-25px"
      >
        <div slot="modalContent">
          <div class="item_title">提示</div>
          <div class="item_content">
            <p>续租成功！</p>
          </div>
          <div class="true_btn blue_font" @click="closeModalRelet">确定</div>
        </div>
      </Modal>
  </div>
</template>
<script>
import NavBar from "components/common/NavBar";
import Modal from "components/common/modal/Modal";
import Nodata from "components/content/nodata/Nodata";
import Foot from "../../components/Foot.vue";
import moment from "moment";
import { timeFormat, isNull } from "common/utils";
import { postStudentAccContinue,getStudentAccommodationList,getStudentAccommodationInfo } from '@/network/accommodation.js'
import { Toast } from 'vant';
export default {
  name: "HousingRelet",
  components: {
    NavBar,
    Modal,
    Nodata,
    Foot,
  },
  data() {
    return {
      
      isNodata: false,
      nodata: {
        imgpath: require("../../assets/images/nodata.png"),
        text: "暂无数据",
      },
      isModal: false,
      isModal2:false,
      isModalRelet:false,
      columns: [
        // { id: 1, text: "1个月" },
        { id: 2,text: "2个月" },
        { id: 3,text: "3个月" },
        { id: 6,text: "6个月" },
      ],
      studentAccommodationId:'',
      expirationTime:null,// 上次到期时间
      reletTime: "", //续租时间
      startData: "", //租赁时间
      endData: "",
      leaseShow: false, //租赁时间
      rent: "", //租金
      premium: "", //保险费
      pickerShow: false,
      checked: false,
      currentIndex: 0,
      time: [],
      minDate:new Date(),
      isSign:false,// 上周期是否有合同待签订
      maxDate:new Date(),
      defaultData:[],
      insurance:0,//保险费
      isInsurance: false,//是否保险费
      monthMoney:null,//租金
      signId:null,
      isDisabled:false,
      insureChecked:true,// 保险勾选
      insureDisabled: true, //保险勾选 不能修改
      isPremium: false,
    };
  },
  mounted(){
    this.getStudentAccommodationData()
   
  },
  computed: {
    "rent1" () {
      return this.reletTime*this.monthMoney
    },
  },
  watch: {
    // 根据续租限制最大选择日期
    'reletTime': {
        handler(newVal, oldVal) {
          this.startData = moment(new Date()).format("YYYY-MM-DD")
          this.endData = this.getNowdate(Number(newVal))
          if(this.isPremium){
            this.insurance = 0
          }else{
            this.insurance = this.reletTime * 30
          }
          
        },
        deep: true,
        
    }
  },
  methods: {
    
    //计算num个月后的时间
    getNowdate(n) {
      let date_now = new Date()
      let  year = date_now.getFullYear() //获取当前时间的年份    
      let  month = date_now.getMonth() + 1 //获取当前时间的月份
      let  day = date_now.getDate() //获取当前时间是几号
      let num, date_end, days; // 备用变量 后面要用
    
      // 以下开始计算n个月后的日期 
      month = Number(month) + n
      num = parseInt(month / 12);
      if (month > 12) {
        num = month % 12 == 0 ? num - 1 : num; //注：month % 12 == 0时,num-1，若12月的12个月后其实是明年的12月 num应是1 不是2
        year = year + num; //月份大于12个月 年份+num
        month = month % 12 == 0 ? 12 : parseInt(month) % 12; //大于12对12取余数，余数为0时=12月
      }
    
      //考虑到如果当前日期是【2022-03-31】半年后的9月却只有30天
      date_end = new Date(year, month, 0); //这里可以拿到n个月后的最后一天的日期
      days = date_end.getDate(); //n个月后的最后一天是几号
      if (day > days) {
        day = days //若n个月后没有31号，就取那个月的最后一天，例如：2022-03-31 6个月后只有 2022-09-30
      }
      return year + '-' + month + '-' + day
    },
 
    timeFormat,
    async getStudentAccommodationData(){
      const res = await getStudentAccommodationList()
      // // 获取状态为到期未退租的住宿信息，判断条件id=8
      // res.result.map((item)=>{
      //   if(item.state == 8) return this.studentAccommodationId = item.id
      // })
      // 提前续租，不需要判断状态--yst，刘总需求20231008
      this.studentAccommodationId = res.result[0].id
      if(this.studentAccommodationId !== ''){     
        this.getStudentAccInfoData()
      }
 
    },
    // 获取房屋到租信息
    async getStudentAccInfoData(){
      const res = await getStudentAccommodationInfo(this.studentAccommodationId)
      if(res.result && res.code == 1){
        this.expirationTime = res.result.endTime
         
        this.insurance = res.result.insurance
        this.isInsurance = res.result.isInsurance
        // this.insurance = 0
        this.monthMoney = res.result.monthMoney
        if(this.isInsurance){
          
          this.isPremium = true
          this.insurance = 0
        }else{
          this.isPremium = false
          
        }
      }
    },
    // 续租时间
    pickerClick() {
      this.pickerShow = true;
    },
    closePopup() {
      this.pickerShow = false;
      this.$refs.pickerRef.setColumnIndex(0, this.currentIndex);
    },
    onConfirm(value, index) {
      this.pickerShow = false;
      this.reletTime = value.id;
      this.currentIndex = index;
    },
   
    onConfirmLease(value) {
      this.time = value;
      this.leaseShow = false;
      this.startData = moment(value[0]).format("YYYY-MM-DD");
      this.endData = moment(value[1]).format("YYYY-MM-DD");
    },
    onClose() {
      this.$refs.calendar.reset();
    },
    checkboxClick() {
      this.checked != this.checked;
    },
    // 保险勾选
    insureClick(){
    },
    // 关闭提示框
    closeModalRelet(){
      // 跳转到支付
      this.$router.replace('/accommodation');
    },
    closeModal2(){
      // 调整到签订合同页
      this.$router.push({ 
        path: "/AgreementRecord/sign" ,
        query: { id: this.signId}
      });
    },
    // 提交续租
    async submitClick() {
      
      //续租时间
      if(this.reletTime === ''){
        this.$confirm.show("请选择续租时间");
        return
      }
      if (!this.checked) {
        this.$confirm.show("请勾选上周期内租赁合同续租期间继续有效");
        return;
      }
      this.isDisabled = true
      let params = {
        studentAccommodationId:this.studentAccommodationId,
        monthNum:this.reletTime

      }
      if(this.insureChecked){
        params.insurance = this.insurance
      }else{
        params.insurance = 0
      }
      console.log(params);
      postStudentAccContinue(params).then((res)=>{
      
        if(res.code == 1){
          this.isModalRelet = true
          this.isDisabled = false
        }else if(res.code == 0 && res.result){
          //上周期是否有合同待签订
          this.isModal2 = true
          this.signId = res.result
          this.isDisabled = false
          return
        }else{
          this.isDisabled = false
          this.$confirm.show(res.message);
        }
      }).catch(()=>{
        this.isDisabled = false
      })
      
      
    },
   
    
  },
};
</script>
<style scoped>
.container {
  height: 100%;
  
}
.opacity{
  opacity: 0.3;
}
.pay_detail li span .public_icon {
  width: 34px;
  height: 34px;
}

.pay_list {
  line-height: 88px;
  width: 100vw;
  text-align: center;
  font-weight: bold;
}
.item_title {
  margin: 40px 0 36px 0;
  text-align: center;
  font-size: 32px;
  color: #000;
}
.pay_group {
  width: 100%;
  height: 100vh;

}
.red{
  color: #fd5252;
}
.tips{
  
  color: #606266;
}
.rental_content {
  border: 1px solid #ebedf0;
  margin: 20px 10px;
  display: flex;
  flex-direction: column;
}
.flex {
  display: flex;
  width: 100%;
}
.rental_table {
  display: flex;
  flex-direction: column;
}
.houseGroup_info{
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  
  margin-bottom: 20px;
}
.info_list{
  height: 90px;
  line-height: 90px;
  border-bottom: 1px solid #f4f6f8;
  padding: 0 20px; 
  display: flex;
  justify-content: space-between;
}
.left_info{
  color: #606266;
}
.right_info{
  color: #606266;
  padding-right: 20px;
}
.table_tl {
  width: 30%;
  border-right: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
  padding: 20px 0 20px 20px;
  box-sizing: border-box;
}
.table_tl2 {
  width: 100%;
  border-bottom: 1px solid #ebedf0;
  padding: 20px 0 20px 20px;
  box-sizing: border-box;
  text-align: center;
}
.table_tr {
  width: 70%;
  padding: 20px 0 20px 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #ebedf0;
  text-align: center;
}
.btn-submit{
  width: 90%;
  height: 80px;
  border-radius: 40px;
  background-color: #5391ff;
  margin: 0 auto;
  color: #fff;
  position: absolute;
  bottom: 100px;
  left: 5%;
}
.red {
  color: #ec4a5d;
}
.tips2{
  
  padding: 0 20px;
}
.checkbox{
  display: inline-block;
  margin-left: 10px;
  vertical-align: middle;
}
.table_footer {
  /* display: flex; */
  text-align: center;
 
  /* align-items: flex-start; */
  border-bottom: 1px solid #ebedf0;
  padding: 20px 25px;
  box-sizing: border-box;
}
.table_Record{
  margin: 0 auto;
}
.blue_color{
  color: #5391ff;
}

.margin_left {
  margin: 0 0 0 20px;
}

.foot.wrap.none {
  position: absolute;
  bottom: 0;
}

.item_content {
  text-align: center;
  margin: 50px 28px;
  font-size: 28px;
}

.true_btn {
  margin-top: 18px;
  padding: 28px 0;
  text-align: center;
  border-top: 1px solid #eee;
}

.gary {
  color: #afb2b5;
}

.van-calendar__popup.van-popup--bottom,
.van-calendar__popup.van-popup--top {
  height: 49%;
}
/deep/.van-checkbox__icon--round .van-icon {
  border-radius: 0% !important;
}
/deep/.van-calendar__confirm {
  height: 70px !important;
  /* margin-bottom: 20px; */
}
/deep/.van-calendar__day {
  height: 100px !important;
}
/deep/.wrap-content{
  text-align: center;
}
/deep/.van-ellipsis{
  font-size: 35px;
}
/deep/.van-picker__cancel{
  font-size: 35px;
}
/deep/.van-picker__confirm{
  font-size: 35px;
}
</style>
